var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28042",
    "data-name": "Group 28042",
    transform: "translate(-1149.5 -309.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1724",
    "data-name": "Ellipse 1724",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1149.5 309.421)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_edit-2",
    "data-name": "vuesax/bold/edit-2",
    transform: "translate(469.5 61.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    transform: "translate(684 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5,1H.5A.5.5,0,0,1,0,.5.5.5,0,0,1,.5,0h12a.5.5,0,0,1,.5.5A.5.5,0,0,1,12.5,1Z",
    transform: "translate(1.502 13.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.776.984a2.416,2.416,0,0,0-3.891,0l-.808.808a.278.278,0,0,0-.067.267A5.425,5.425,0,0,0,3.7,5.749a.335.335,0,0,0,.08.013.267.267,0,0,0,.194-.08l.8-.808a2.759,2.759,0,0,0,.981-1.929A2.748,2.748,0,0,0,4.776.984Z",
    transform: "translate(7.901 1.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.087,3.657c-.194-.093-.38-.187-.561-.294-.147-.087-.287-.18-.427-.28A4.03,4.03,0,0,1,6.725,2.8a.814.814,0,0,1-.113-.1A5.645,5.645,0,0,1,5.924,2a.813.813,0,0,1-.1-.12,3.882,3.882,0,0,1-.28-.367,3.665,3.665,0,0,1-.26-.394c-.107-.18-.2-.36-.294-.547S4.823.18,4.756,0L.565,4.191a.8.8,0,0,0-.187.367L.017,7.115a1.368,1.368,0,0,0,.34,1.168,1.329,1.329,0,0,0,.934.36,1.459,1.459,0,0,0,.24-.02L4.1,8.263a.743.743,0,0,0,.367-.187L8.654,3.884C8.467,3.818,8.287,3.744,8.087,3.657Z",
    transform: "translate(2.332 4.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    transform: "translate(16 16) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCircle);
export default __webpack_public_path__ + "static/media/pencil-circle.5ebf0d94bc0147c83caabc1b41af057c.svg";
export { ForwardRef as ReactComponent };